import { useEffect, useState } from "react";
import { Star, ListChecks } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";

// Teacher: every reading-quiz result of the selected class, newest first.
export const QuizResults = ({ classId }) => {
  const { t } = useLang();
  const tq = t.quiz;
  const [rows, setRows] = useState(null);
  useEffect(() => {
    setRows(null);
    if (!classId) return;
    api.get(`/teacher/classes/${classId}/quiz-results`).then((r) => setRows(Array.isArray(r.data) ? r.data : [])).catch(() => setRows([]));
  }, [classId]);

  return (
    <section className="mt-12" data-testid="teacher-quiz-results">
      <h2 className="font-display text-2xl font-bold mb-4 inline-flex items-center gap-2"><ListChecks className="w-6 h-6 text-[#047857]" /> {tq.teacherTitle}</h2>
      {rows === null ? null : !rows.length ? (
        <p className="text-stone-600" data-testid="teacher-quiz-results-empty">{tq.teacherEmpty}</p>
      ) : (
        <div className="bg-white border border-[#E5DCCB] overflow-x-auto" data-lenis-prevent>
          <table className="w-full text-sm min-w-[560px]">
            <thead className="bg-[#F2ECE1] text-stone-700">
              <tr>{[tq.colStudent, tq.colBook, tq.colScore, tq.colStars, tq.colDate].map((h) => <th key={h} className="text-start font-semibold px-4 py-3">{h}</th>)}</tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={`${r.student_id}-${r.book_id}`} className="border-t border-[#E5DCCB]" data-testid={`teacher-quiz-row-${r.student_id}-${r.book_id}`}>
                  <td className="px-4 py-3 font-semibold">{r.name}</td>
                  <td className="px-4 py-3" dir="auto">{r.book_title}</td>
                  <td className="px-4 py-3 font-bold" dir="ltr">{r.score} / {r.total}</td>
                  <td className="px-4 py-3">
                    <span className="inline-flex gap-0.5" aria-label={`${r.stars}/3`}>
                      {[0, 1, 2].map((i) => <Star key={i} className={`w-4 h-4 ${i < r.stars ? "fill-[#FBBF24] text-[#F59E0B]" : "text-stone-300"}`} />)}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-stone-600">{new Date(r.created_at).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};
